import { ArticleParagraph3, IconPhoto16 } from '@cian/ui-kit';

import { clsx } from 'clsx';
import { FC } from 'react';

import { ICounter } from './types';

import * as styles from './styles.css';

export const Counter: FC<ICounter> = props => {
  const { currentSlide, totalSlides, className } = props;

  return (
    <div className={clsx(styles['root'], className)}>
      <IconPhoto16 color="white_100" />
      <span className={styles['caption']}>
        <ArticleParagraph3 color="white_100">{`${currentSlide}/${totalSlides}`}</ArticleParagraph3>
      </span>
    </div>
  );
};

Counter.displayName = 'Counter';
